import { t } from 'i18next';
import { urlHelper } from 'src/app/helpers';
import { getFormData } from 'src/app/helpers/form.helper';
import { apiSlice } from 'src/app/redux/api/apiSlice';
import { ImportDataType } from 'src/app/redux/interests/interest-slice.type';
import { RelationInterestLookupDataType } from 'src/app/services/interest/interest.service.type';
import { RelationRecognizedResultType } from 'src/app/services/interest/Relation/relation-service.type';
import { finalUrlsConfig } from 'src/configs/url.config';

export const relationSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getRelations: builder.query<RelationRecognizedResultType, RelationInterestLookupDataType | void>({
      query: (params?: RelationInterestLookupDataType) => ({
        url: finalUrlsConfig().interest.identified.relation.types,
        params: urlHelper.getLookupQuery(params),
      }),
      providesTags: (result) =>
        result
          ? [
              ...result.rows.map(({ id }) => ({
                type: 'Relations' as const,
                id,
              })),
              { type: 'Relations', id: 'LIST' },
            ]
          : [{ type: 'Relations', id: 'LIST' }],
    }),
    exportRelationExcell: builder.mutation<ArrayBuffer, { ids?: string[] }>({
      query: (data) => ({
        url: finalUrlsConfig().exports.relation,
        method: 'POST',
        body: data,
        responseHandler: async (response: any) => {
          if (!response.ok) {
            const errorResponse = await response.json();
            throw new Error(errorResponse?.message || t('errors.defaultErrorText'));
          }
          return response.blob();
        },
        cache: 'no-cache',
      }),
    }),
    importRelation: builder.mutation<void, ImportDataType>({
      query: (data) => ({
        url: finalUrlsConfig().interest.identified.relation.import,
        method: 'POST',
        body: getFormData(data, ['file']),
      }),

      invalidatesTags: [{ type: 'Interactions', id: 'LIST' }],
    }),
  }),
});

export const {
  useExportRelationExcellMutation,
  useGetRelationsQuery,
  useLazyGetRelationsQuery,
  useImportRelationMutation,
} = relationSlice;
